import { render, staticRenderFns } from "./Accordian.vue?vue&type=template&id=ec941986&scoped=true&"
import script from "./Accordian.vue?vue&type=script&lang=js&"
export * from "./Accordian.vue?vue&type=script&lang=js&"
import style0 from "./Accordian.vue?vue&type=style&index=0&id=ec941986&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec941986",
  null
  
)

export default component.exports